import { LookupSelect } from 'components/Lookups/LookupSelect';
import React from 'react';
import { LookupModel } from 'types/graphql';
import { KbsGroupLookupWrapper } from 'components/Lookups/KbsGroupLookups/KbsGroupLookupWrapper';

interface IProps {
  includeDeleted?: boolean;
  selectedId?: number | null;
  onSelect: (item?: LookupModel) => void;
}

export const KbsGroupSelect = (props: IProps): JSX.Element => {
  return (
    <KbsGroupLookupWrapper includeDeleted={props.includeDeleted}>
      {({ queryDocument, queryVariables, extractLookups }) => (
        <LookupSelect
          extractLookupItems={extractLookups}
          queryDocument={queryDocument}
          queryVariables={queryVariables}
          selectedId={props.selectedId}
          onSelect={props.onSelect}
        />
      )}
    </KbsGroupLookupWrapper>
  );
};
